import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  status: 'idle', // idle | loading | succeeded | failed
  error: null,
  refetchRequested: false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfileData(state, action) {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
      state.refetchRequested = false;
    },
    setProfileLoading(state) {
      state.status = 'loading';
      state.error = null;
    },
    setProfileError(state, action) {
      state.status = 'failed';
      state.error = action.payload || 'Unknown error';
    },
    resetProfile(state) {
      state.data = null;
      state.status = 'idle';
      state.error = null;
      state.refetchRequested = true;
    },
  },
});

export const { setProfileData, setProfileLoading, setProfileError, resetProfile } = profileSlice.actions;

export const selectProfile = (state) => state.profile.data;
export const selectProfileStatus = (state) => state.profile.status;
export const selectProfileError = (state) => state.profile.error;
export const selectProfileRefetchRequested = (state) => state.profile.refetchRequested;

export default profileSlice.reducer;
